import { useEffect, useMemo, useRef, useState } from "react";
import { money } from "../lib/finance";
import { FileText, Megaphone, Search, Users } from "lucide-react";

export function GlobalSearchModal({ policies, customers, quotes, vehicles, setPage, onOpenCustomer, onOpenPolicy, onOpenQuote, onClose }) {
  const [q, setQ] = useState("");
  const inputRef = useRef(null);
  useEffect(() => { inputRef.current?.focus(); }, []);
  const results = useMemo(() => {
    const needle = q.trim().toLocaleLowerCase("tr");
    if (!needle) return { customers: [], policies: [], quotes: [] };
    const match = (s) => (s || "").toLocaleLowerCase("tr").includes(needle);
    const cRows = customers.filter((c) => match(c.name) || match(c.phone) || match(c.email) || match(c.tcKimlik)).slice(0, 8);
    const pRows = policies.filter((p) => match(p.policeNo) || match(p.customer) || match(p.plate) || match(p.company) || match(p.branch)).slice(0, 8);
    const qRows = quotes.filter((qt) => match(qt.customerName) || match(qt.plate) || match(qt.company) || match(qt.branch) || match(qt.customerPhone)).slice(0, 6);
    return { customers: cRows, policies: pRows, quotes: qRows };
  }, [q, customers, policies, quotes]);
  const totalHits = results.customers.length + results.policies.length + results.quotes.length;
  return (
    <div className="modal-backdrop global-search-backdrop" data-testid="global-search-modal" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="global-search-panel">
        <div className="global-search-head">
          <Search size={18} />
          <input ref={inputRef} data-testid="global-search-field" placeholder="Plaka, müşteri, TC, telefon, poliçe no, branş..." value={q} onChange={(e) => setQ(e.target.value)} />
          <kbd className="kbd-hint">ESC</kbd>
        </div>
        <div className="global-search-results">
          {!q.trim() && (
            <div className="search-hint">
              <small>Ne arıyorsunuz? Her yerden açmak için <kbd>⌘K</kbd> / <kbd>Ctrl+K</kbd></small>
              <ul>
                <li>Müşteri adı, telefon, TC</li>
                <li>Poliçe numarası, plaka, şirket</li>
                <li>Teklif müşterisi, branş</li>
              </ul>
            </div>
          )}
          {q.trim() && totalHits === 0 && <div className="search-hint muted" data-testid="global-search-empty">"{q}" için eşleşme bulunamadı.</div>}
          {results.customers.length > 0 && (
            <div className="search-group">
              <div className="search-group-head"><Users size={13} /> Müşteriler · {results.customers.length}</div>
              {results.customers.map((c) => (
                <button key={c.id} type="button" className="search-item" data-testid={`search-customer-${c.id}`} onClick={() => onOpenCustomer(c)}>
                  <strong>{c.name}</strong>
                  <span className="muted small">{c.phone || "—"} · {c.email || "—"}</span>
                </button>
              ))}
            </div>
          )}
          {results.policies.length > 0 && (
            <div className="search-group">
              <div className="search-group-head"><FileText size={13} /> Poliçeler · {results.policies.length}</div>
              {results.policies.map((p) => (
                <button key={p.id} type="button" className="search-item" data-testid={`search-policy-${p.id}`} onClick={() => onOpenPolicy(p)}>
                  <strong>{p.policeNo || "—"} · {p.customer}</strong>
                  <span className="muted small">{p.branch} · {p.plate || "—"} · {p.company || ""}</span>
                </button>
              ))}
            </div>
          )}
          {results.quotes.length > 0 && (
            <div className="search-group">
              <div className="search-group-head"><Megaphone size={13} /> Teklifler · {results.quotes.length}</div>
              {results.quotes.map((qt) => (
                <button key={qt.id} type="button" className="search-item" data-testid={`search-quote-${qt.id}`} onClick={() => onOpenQuote(qt)}>
                  <strong>{qt.customerName} · {qt.status}</strong>
                  <span className="muted small">{qt.branch} · {qt.plate || "—"} · {qt.premium ? money(qt.premium) : ""}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// Export Crown badge wrapper for Customers list (small utility)
